// Ikoner från https://www.svgrepo.com/ men modifierade.
// Har tagit bort några path som fungerade likt stroke och lagt till vanlig stroke.
// Egna färger i fill.

export const Sun = `
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 483.512 483.512" xml:space="preserve">
        <polygon 
            fill=#fdda20 stroke="black" stroke-width="30"
            points="475.512,241.691 421.2,289.571 444.016,358.283 372.952,372.267 358.336,443.203 
            289.76,419.915 241.752,474.131 193.752,419.915 125.168,443.203 110.552,372.259 39.488,358.275 62.312,289.563 8,241.691 
            62.312,193.819 39.488,125.107 110.56,111.123 125.176,40.187 193.752,63.467 241.752,9.259 289.76,63.475 358.336,40.187 
            372.952,111.131 444.024,125.115 421.2,193.827 "
        />
        <circle 
            fill=rgb(255,239,0) stroke="black" stroke-width="20"
            cx="241.752" cy="244.339" r="133.64"
        />
    </svg>
`
// viewBox är ändrad för att göra ikonen lite större, orginal är "0 0 24 24"
export const Moon = `
    <svg viewBox="0 1 22 22" xmlns="http://www.w3.org/2000/svg">
        <path 
            stroke=black stroke-width=1.5 fill=#ffef00
            d="M3 17C10.952 18.6176 16.6829 8.75775 11 3C16.0007 3.13144 20 7.11149 20 12C20 16.9715 16.1188 21 11 21C7.77111 21 4.65938 19.4319 3 17Z"
        />
    </svg>
`
